import React from "react";
import { FormOutlined } from "@payping/icons";
import { Button, Col, Descriptions, Image, Row, Space, Typography } from "@payping/web-components";
import { useAppDispatch, useAppSelector, useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import { useAsyncRetry } from "react-use";
import { getUserBusinessinfo, getUserLocalInformation } from "@payping/redux/actions";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";

const BusinessList: React.FC = () => {
  const dispatch = useAppDispatch();
  const businessInfo = useAppSelector((state) => state.user.businessInfo);
  const localInfo = useAppSelector((state) => state.user.localInfo);
  const businessDocuments = useAppSelector((state) => state.user.businessInfo?.documents);
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  useAsyncRetry(async () => {
    await dispatch(getUserLocalInformation());
    await dispatch(getUserBusinessinfo());
  }, [dispatch]);

  return (
    <Row className={"tw-w-full"}>
      <Col span={24} className={"tw-mb-4"}>
        <div className={"tw-flex tw-w-full tw-flex-row tw-justify-between"}>
          <Typography.Title className="tw-font-medium" level={4}>
            {t("profile.main.business")}
          </Typography.Title>
          <Button
            type={"primary"}
            icon={<FormOutlined width={14} height={14} />}
            onClick={() => navigate(DashboardRoutes.settings.business.edit.url)}
          >
            {t("edit")}
          </Button>
        </div>
      </Col>
      <Col span={24}>
        <Descriptions column={2}>
          <Descriptions.Item label={t("businessName")}>{businessInfo?.businessName}</Descriptions.Item>
          <Descriptions.Item label={t("state")}>{localInfo?.state}</Descriptions.Item>
          <Descriptions.Item label={t("settings.business.description")}>
            {businessInfo?.businessDescription}
          </Descriptions.Item>
          <Descriptions.Item label={t("county")}>{localInfo?.city}</Descriptions.Item>
          <Descriptions.Item label={t("report.sidebar.customer.postalCode")}>{localInfo?.postalCode}</Descriptions.Item>
          <Descriptions.Item label={t("settings.business.postalAddress")}>{localInfo?.address}</Descriptions.Item>
          <Descriptions.Item label={t("localPhone")}>{localInfo?.localPhone}</Descriptions.Item>
          <Descriptions.Item label={t("taxCode")}>{businessInfo?.taxCode}</Descriptions.Item>
          <Descriptions.Item label={t("settings.business.websiteAddress")}>{businessInfo?.site}</Descriptions.Item>
          <Descriptions.Item label={t("settings.business.officialBusinessName")}>
            {businessInfo?.companyName}
          </Descriptions.Item>
          <Descriptions.Item label={t("settings.business.sabtNumber")}>{businessInfo?.sabtNumber}</Descriptions.Item>
          <Descriptions.Item label={t("settings.business.registrationDate")}>
            {
              toJalali({
                date: businessInfo?.registrationDate,
                dateFormat: dateFormats.ui.utcDateTime,
                toFormat: dateFormats.ui.utcDate,
              }).string
            }
          </Descriptions.Item>
          <Descriptions.Item label={t("settings.business.bNationalCode")}>
            {businessInfo?.bNationalCode}
          </Descriptions.Item>
          <Descriptions.Item label={t("settings.business.economicCode")}>
            {businessInfo?.economicCode}
          </Descriptions.Item>
          <Descriptions.Item label={t("settings.business.certificateOfEstablishmentAndLetterOfIntroduction")}>
            &nbsp;
          </Descriptions.Item>
        </Descriptions>
        <Space>{businessDocuments?.map((img, i) => <Image key={i} width={100} src={img.serverName} />)}</Space>
      </Col>
    </Row>
  );
};

export default BusinessList;
